import * as React from 'react'

function TrashIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={19} height={18.4} viewBox="0 0 19 18.4" {...props}>
      <g
        data-name="Group 52930"
        transform="translate(-934.942 -392.111)"
        fill="none"
        stroke="#263238"
        strokeWidth={1.4}
      >
        <path data-name="Path 12831" d="M941.281 395.52a3.2 3.2 0 016.322 0" strokeLinejoin="round" />
        <path data-name="Path 12832" d="M937.318 396.258v13.553h14.248v-13.553" />
        <path data-name="Line 330" transform="translate(934.942 396.005)" d="M0 0L19 0" />
        <path data-name="Line 421" transform="translate(941.117 400.962)" d="M0 0L0 5.234" />
      </g>
    </svg>
  )
}

export default TrashIcon
